module.exports = __webpack_public_path__ + "img/messer_px.011c26f3.png";